import { Errors, Paging } from "./generic";
import { ProcessNames } from "./reverse/process.model";

export class filterRequest {
    itemId : string;
    itemDesc : string;
    itmDelFlag : string;
}

export class ItemSummay {
    items: unifiedItemModel[];
    paging: Paging;
    errors?: Errors;
}

export class ItemMaster {
    item: unifiedItemModel;
    requestIdentifier: string;
    transactionDate: string;
    success: boolean;
    errors?: Errors;
}

export class RItemMaster {
    items: unifiedItemModel[] = [];
    requestIdentifier: string;
    transactionDate: string;
    success: boolean;
    errors?: Errors;
}

export class ItemMaster2 {
    items: unifiedItemModel[];
    requestIdentifier: string;
    transactionDate: string;
    success: boolean;
    errors?: Errors;
}

export class Item {
    user?= 'Portal';
    itemId?: number;
    businessUnit?: string;
    facility?: string;
    cost?: number;
    productTypeDesc?: string;
    cycleCountDesc?: string;
    trans_uuid?: string;
    creationDate?: string;
    actionType?: string;
    messageType?: string;
    source?: string;
    dataSource?= 'Portal';
    itemProfile?: string;
    itemName?: string;
    description?: string;
    departmentClass?: string;
    departmentSubClass?: string;
    longDescription?: string;
    itemBarCode?: string;
    upcGTIN?: string;
    qtyUOM?: string;
    primaryComponent?: string;
    isRekit?: string;
    isRepair?: string;
    baseStorageUOM?: string;
    costCurrency?: string; // currencycode
    unitPrice?: number;
    currencyCode?: string;
    retailPrice?: number;
    minimumShippableQuantity?: string
    commodityCode?: string;
    commodityDesc?: string;
    hazard?: boolean;
    interNational?: boolean;
    ltl?: boolean;
    hazardousCode?: string;
    weight?: number;
    weightUOM?: string;
    volume?: number;
    volumeUOM?: string;
    stackable?: string;
    returnable?: boolean;
    exchangeable?: boolean;
    returntoStore?: boolean;
    season?: string;
    seasonYear?: string;
    style?: string;
    styleSfx?: string;
    sizeDescription?: string;
    color?: string;
    colorSfx?: string;
    colorDescription?: string;
    productType?: string;
    productClass?: string;
    itemOperationsMake?: string;
    itemOperationsModel?: string;
    itemOperationsSize?: string;
    itemOperationsColor?: string;
    itemOperationsPackType?: String;
    nmfc?: string;
    nmfcFreightClass?: string;
    eccn?: string;
    harmonizedTariffSchedule?: string;
    freightCode?: string;
    protectionFactor?: string;
    kitItem?: string;

    //rlog-fields
    depId?: string;
    destination?: string;
    rptId?: string;
    venId?: string;
    returnType?: string;
    model?: string;
    fragile?: string;
    labelRequired?: string;
    hazmatRequired?: string;
    outboundWarehouse?: string;
    srlNbrValidation?: string;
    srlNbrLength?: string;
    authFlag?: string;
    packQty?: string;
    serialNumbertype?: string;
    productCode?: string;
    itemBrand?: string;
    iccidType?: string;
    lineofBusiness?: string;
    oEm?: string;
    skuType?: string;
    parentSku?: string;
    itemGrade?: string;
    manufacturerPartnumber?: string;
    caToxicitytype?: string;
    manufacturerName?: string;
    deleted?: string;
    itemVersion?: string;
    nonattDevicetype?: string;
    nonattLifecycle?: string;
    nonattModel?: string;
    carrier?: string;
    batteryPackaging?: string;
    batteryTechnology?: string;
    batteryWeight?: string;
    batteryWatthours?: string;
    batteryNumofcells?: string;
    firstnetCapable?: string;
    iccidPrefix?: string;
    camfgPkgwarning?: string;
    expiryDateTracked?: string;
    scnTimePutawayReqd?: string;
    scnStpMixedSbLoc?: string;
    scnTimePutawayLocClass?: string;
    firstReceipt?: string;

    /** sub-arrays */
    businessUnitName?: BusinessUnitName;
    dimensions?: Dimensions;
    tracking?: Tracking;
    valueAddedServiceName?: ValueAddedServiceName;
    organizations?: Organizations[] = [];
    uomConversions?: UomConversions[] = [];
    crossreferences?: Crossreferences[] = [];
    valueAddedServices?: ValueAddedServices[] = [];
    consolidatedUom?: ConsolidatedUom[] = [];
    priceLists?: PriceLists[] = [];
    categories?: Categories[] = [];
    costs?: Costs[] = [];
    zones?: Zones[] = [];
    xrefs?: Xref[];
    itemSlotting?: ItemSlotting[] = [];
    kitItems?: KitItemDetails[] = [];
    processDetails?: ProcessNames[] = [];
    custVendorNumber?: string;
    vendorCode?: string;
}

export class unifiedItemReqModel {
    item: unifiedItemModel;
    items: unifiedItemModel[] = [];
    requestIdentifier: string;
    transactionDate: string;
    success: boolean;
    errors?: Errors;
}

export class unifiedItemModel {  
    actionType?: string;
    authFlag?: string;
    baseStorageUOM?= 'EA';
    custId?: string;
	fcyId?: string;
	buId?: string;
    batteryNumofcells?: string;
    batteryPackaging?: string;
    batteryTechnology?: string;
    batteryWatthours?: string;
    batteryWeight?: string;
    businessUnit?: string;
    businessUnitName?: BusinessUnitName;
    buUnit?: string;
    camfgPkgwarning?: string;
    carrier?: string;
    categories?: Categories[] = [];
    categorycode?: string;
    categorytype?: string;
    caToxicitytype?: string;
    color?: string;
    colorDescription?: string;
    colorSfx?: string;
    commodityCode?: string;
    commodityDesc?: string;
    consolidatedUom?: ConsolidatedUom[] = [];
    cost?: number;
    costs?: Costs[] = [];
    creationDate?: string;
    crossreferences?: Crossreferences[] = [];
    cycleCountDesc?: string;
    dataSource?= 'Portal';
    deleted?: string;
    departmentClass?: string;
    departmentSubClass?: string;
    depId?: string;
    description?: string;
    destination?: string;
    dimensions?: Dimensions;
    eccn?: string;
    exchangeable?: boolean;
    expiryDateTracked?: string;
    facility?: string;
    firstnetCapable?: string;
    firstReceipt?: string;
    fragile?: string;
    freightCode?: string;
    harmonizedTariffSchedule?: string;
    hazard?: boolean;
    hazardousCode?: string;
    hazardous?: hazardousInfo;
    hazmatRequired?: string;
    iccidPrefix?: string;
    iccidType?: string;
    icon?: string;
    interNational?: boolean;
    itemBarCode?: string;
    itemBrand?: string;
    itemGrade?: string;
    itemId?: number;
    itemName?: string;
    itemOperationsColor?: string;
    itemOperationsMake?: string;
    itemOperationsModel?: string;
    itemOperationsPackType?: String;
    itemOperationsSize?: string;
    itemProfile?: string;
    itemSlotting?: ItemSlotting[] = [];
    itemVersion?: string;
    itmAuthFlag?: string;
    itmAuxId?: string;
    itmBarcode?: string;
    itmClass?: string;
    itmClassDescription?: string;
    itmColor?: string;
    itmComCode?: string;
    itmComDesc?: string;
    itmEACost?: string;
    itmCost1?: string;
    itmCost2?: string;
    itmCost3?: string;
    itmCost4?: string;
    itmCost5?: string;
    itmCountryOfOriginRequired?: string;
    itmCurrencyId?: string;
    itmCusId?: string;
    itmDeletedFlag?: string;
    itmDepId?: string;
    itmDeptClass?: string;
    itmDeptSubClass?: string;
    itmDescription?: string;
    itmDestination?: string;
    itmDownloadBy?: string;
    itmDownloadDate?: string;
    itmDownloadTime?: string;
    itmEccn?: string;
    itmExpRecDays?: string;
    itmExpTrack?: string;
    itmFhtCode?: string;
    itmFragile?: string;
    itmUNNumber?: string;
    itmHazmatFlag?: string;
    itmHight?: string;
    itmHts?: string;
    itmId?: string;
    itmKittingFlag?: string;
    itmLabelRequired?: string;
    itmLength?: string;
    itmLotTrack?: string;
    itmModel?: string;
    itmMsn?: string;
    itmNmfc?: string;
    itmOutboundWarehouse?: string;
    itmPackQty?: string;
    itmProductClass?: string;
    itmProductType?: string;
    itmPrtFac?: string;
    itmQty?: string;
    itmRepackPalletQty?: string;
    itmRetail1?: string;
    itmRetail2?: string;
    itmRetail3?: string;
    itmRetail4?: string;
    itmRetail5?: string;
    itmReturnType?: string;
    itmRptId?: string;
    itmSeason?: string;
    itmSeasonYear?: string;
    itmSerialNumLength?: string;
    itmSerialNumRequired?: string;
    itmSerialNumValidation?: string;
    itmShelfDays?: string;
    itmShpHeight?: string;
    itmShpLength?: string;
    itmShpWidth?: string;
    itmSize?: string;
    itmSpecCapture?: string;
    itmStackFlag?: string;
    itmStatus?: string;
    itmStyle?: string;
    itmSubClass?: string;
    itmTempZone?: string;
    itmTrlTempZone?: string;
    itmUnitprice?: string;
    itmUOM?: string;
    itmVasType?: string;
    itmVelCode?: string;
    itmVenId?: string;
    itmVersionNo?: string;
    itmVipFlag?: string;
    itmWeight?: string;
    itmWidth?: string;
    kitItem?: string;
    kitItems?: KitItemDetails[] = [];
    labelRequired?: string;
    lineofBusiness?: string;
    longDesc?: string;
    longDescription?: string;
    ltl?: boolean;
    manufacturerName?: string;
    manufacturerPartnumber?: string;
    messageType?: string;
    minimumShippableQuantity?: string
    model?: string;
    modified?: boolean;
    new?: boolean;
    nmfc?: string;
    nmfcFreightClass?: string;
    nonattDevicetype?: string;
    nonattLifecycle?: string;
    nonattModel?: string;
    oEm?: string;
    organizations?: Organizations[] = [];
    outboundWarehouse?: string;
    packQty?: string;
    parentSku?: string;
    priceLists?: PriceLists[] = [];
    processStatus?: string;
    productClass?: string;
    productCode?: string;
    productType?: string;
    productTypeDesc?: string;
    protectionFactor?: string;
    qtyUOM?: string;
    primaryComponent?: string;
    isRekit?: string;
    isRepair?: string;
    returnable?: boolean;
    innerPackItem?: boolean;
    returntoStore?: boolean;
    returnType?: string;
    rptId?: string;
    scnTimePutawayReqd?: string;
    scnStpMixedSbLoc?: string;
    scnTimePutawayLocClass?: string;
    season?: string;
    seasonYear?: string;
    serialNumbertype?: string;
    sizeDescription?: string;
    skuType?: string;
    source?: string;
    srlNbrLength?: string;
    srlNbrValidation?: string;
    stackable?: string;
    style?: string;
    styleSfx?: string;
    tracking?: Tracking;
    trans_uuid?: string;
    uomConversions?: UomConversions[] = [];
    upcGTIN?: string;
    user?= 'Portal';
    valueAddedServiceName?: ValueAddedServiceName;
    valueAddedServices?: ValueAddedServices[] = [];
    venId?: string;
    volume?: number;
    volumeUOM?: string;
    allocationPriority?:String;
    lotRequired?: string;
    expirationRequired?: string;
    // This is for Ufix
    errorId?: string;
    
    weight?: number;
    weightUOM?: string;
    xrefs?: Xref[] = [];
    zones?: Zones[] = [];
    srlNbrReqd?: string;
    incubationDays?:string;
    incubationHours?:string;
    incubationFlag?:string;
    isUomDeleted?: boolean;
    cubicScan?: string;
    custVendorNumber?: string;
    vendorCode?: string;
    categoryValues?: string;
}

export class hazardousInfo {
    pkgGrpIMDG?: string;
    hazardClassIMDG?: string;
    unNbrIMDG?: string;
    hazmatDivisionText?: string;
}

export class BusinessUnitName {
    id?: string;
    name?: string;
}

export class Categories {
    itemName?: string;
    categorytype?: string;
    categorycode?: string;
    createdTime?: string;
    createdBy?: string;
    lastUpdatedTime?: string;
    lastUpdatedBy?: string;
}

export class Costs {
    costType?: string;
    unitCost?: number;
    costUOM?: string;
    costCurrency?: string;
}

export class Crossreferences {
    referenceType?: string;
    referenceBarcode?: string;
    numberOfUnits?: number;
    downloadDate?: string;
    downloadBy?: string;
    downloadTime?: string;
    versionNo?: number;
    deletedFlag?: string;
}

export class ConsolidatedUom {
    uom?: boolean; // boolean based on EA or Each input
    toUOM?: string;
    conversionRate?: number; // qty
    toUOMUPC?: string;
    height?: number;
    length?: number;
    width?: number;
    dimensionUOM?: string;
    weight?: number;
    weightUOM?: string;
    volume?: number;
    volumeUOM?: string; 
    unitCost?: number; // cost
    priceUOM?: string;
    costUOM?: string;
    qtyUOM?: string;
    cubicScan?: string;
}

export class Dimensions {
    height?: number;
    length?: number;
    width?: number;
    weight?: number;
    dimensionUOM?: string;
}

export class ItemSlotting {
    itemSlotId?: number;
    itemId?: number;
    locationClass?: string;
    locationId?: string;
    locationName?: string;
    uom?: string;
    minQty?: number;
    maxQty?: number;
    maxLocationCount?: number;
}

export class Organizations {
    businessUnit?: string;
    facility?: string;
    companyID?: string;
}

export class Tracking {
    lotRequired?: string;
    expirationRequired?: string;
    countryOfOriginRequired?: string;
    serialNumberRequired?: string;
    minorSerialTracked?: string;
    temperatureZone?: string;
    shelfLifeDays?: number;
    trailerTemperatureZone?: string;
    cycleCountClass?: string;
    maximumReceiveToExpireDays?: number;
    incubationFlag?: string;
	incubationDays?: string;
	incubationHours?: string;
    coo?: string;
    
}

export class UomConversions {
    toUOM?: string;
    conversionRate?: number;
    toUOMUPC?: string;
    height?: number;
    length?: number;
    width?: number;
    dimensionUOM?: string;
    weight?: number;
    weightUOM?: string;
    volume?: number;
    volumeUOM?: string;
    qtyUOM?: string;
    cubicScan?: string;
}

export class ValueAddedServiceName {
    id?: string;
    name?: string;
}

export class ValueAddedServices {
    valueAddedServiceName?: string;
}

export class ValidateBuSku {
    bu: string;
    itemName: string;
    facility: string;
}

export class ValidateItemReq {
    items: ValidateBuSku[];
}

export class ValidateOrg {
    bu: string;
    facility: string;
    itemStatus: string;
    itemId: string;
}

export class ValidateItems {
    itemName: string;
    organizations: ValidateOrg[];
}

export class ValidateItemResp {
    items: ValidateItems[];
    transactionDate: string;
    success: boolean;
}

export class ItemErrorsResponse{
    requestIdentifier: string;
    transactionDate: string;
    success: boolean;
    itemErrorId: number;
    buid: number;
    fcyId: number;
    itemJson: string;
    errors: Error;
}

export class Error{
    code: string;
    errorMessage: string;
}


export class PriceLists {
    priceChannel: string;
    unitPrice?: number;
    retailPrice?: number;
    currencyCode?: string;
    priceUOM?: string;
}

export class ItemZoneModel {
    success: string;
    requestIdentifier: string;
    transactionDate: Date;
    locationGroup: LocationGroupMaster[];
    paging: Paging;
}

export class LocationGroup {
    locationGroupId: number;
    type: string;
    facilityId: number;
    customerId: number;
    code: string;
    description: string;
    locationGroupAttrs: LocationGroupAttributes[];
}

export class LocationGroupMaster {
    locationGroup: LocationGroup
    locationGroupId: number;
    type: string;
    facilityId: number;
    customerId: number;
    createdBy: string;
    code: string;
    description: string;
    locationGroupAttrs: LocationGroupAttributes[];
}

export class LocationGroupAttributes {
    locationGroupAttrId: number;
    attrCode: string;
    attrValue: string;
}

export class KitItemDetails {
    kitId?: string;
    itemId?: string;
    childItemId?: string;
    childItemName?: string;
    childItemDesc?: string;
    sequenceNo?: string;
    qty?: string;
    qtyUom?: string;
    primaryComponent?: string;
    isRekit?: string;
    isRepair?: string;
    batchNbrReqdFlag?: boolean;
    batchNumber?: string;
    cooReqdFlag?: boolean;
    coo?: string;
    active?: string;
    createdTime?: string;
    createdBy?: string;
    toUOMUPC?: string;
    lastUpdatedTime?: string;
    lastUpdatedBy?: string;
    kitItemsAttr?: kitItemsAttrDetails[] = [];
    categoryValues?: any;
    previousCategoryValues?: any;
}

export class kitItemsAttrDetails {
    kitId?: string;   
    key?: string;
    value?: string;
    type?: string;   
    createdTime?: string;
    createdBy?: string;
    lastUpdatedTime?: string;
    lastUpdatedBy?: string;
}

export class Xref {
    xrfItmId: string;
    xrfSec: string;
    xrfCusId: string;
    xrfDownloadDate: Date;
    xrfDownloadBy: string;
    xrfDownloadTime: Date;
    xrfVersionNo: number;
    xrfDeletedFlag: string = 'N';
    icon: string;
    modified: true;
    error: Error;
}

export class Zones {
    itemZoneId?: number;
    itemId?: number;
    zoneGroupId?: number;
    zoneSeq?: number;
    createdTime?: string;
    createdBy?: string;
    lastUpdatedTime?: string;
    lastUpdatedBy?: string;
}

export class HazmatInfo {
    hazardousCode?: string;
    hazardousDivision?: string;
    hazmatUNNumber?: string;
    hazmatPackingGroup?: string;
}
